import { Styles } from 'assets/types';

const agreeToFeeDisclaimer: Styles = () => ({});

export default agreeToFeeDisclaimer;
